// Drift: kundens egen side (Mine bookinger) på Supabase (del af SupabaseApi – se supabase.ts).
// Læsning: mine_data (kun kundens egne rækker – bookinger, billeder, betalinger og medlemskaber).
// Flyt: edge-funktionen "booking" regner prisen (weekend-/helligdagstillæg og gebyr for kort varsel, src/core/flyt.ts)
// og gemmer via databasen – kunden kan aldrig selv sætte prisen.
import type { Api, Betaling, BookingVisning } from './api';
import type { Dokumentation, Kunde } from '../../core/typer';
import type { SbKatalog, SbKontekst } from './sbKatalog';
import { tilVisning } from './sbKontor';
import { tilMedlemskab } from './sbMedlemmer';

type Raa = Parameters<typeof tilVisning>[0];

export class SbKunde {
  constructor(private readonly c: SbKontekst, private readonly kat: SbKatalog) {}

  mineData: Api['mineData'] = async () => {
    const r = (await this.c.k(this.c.sb.rpc('mine_data', { k: await this.c.kraevKlient() }))) as {
      kunde: Kunde; bookinger: Raa[]; dokumentation: Dokumentation[]; betalinger: Betaling[] | null; medlemskaber: Record<string, unknown>[] | null };
    const bookinger: BookingVisning[] = r.bookinger.map(tilVisning);
    return { kunde: r.kunde, bookinger, dokumentation: r.dokumentation, betalinger: r.betalinger ?? [], medlemskaber: (r.medlemskaber ?? []).map(tilMedlemskab) };
  };
  // Kundens eget samtykke til tilbud og nyheder (20261029800100_samtykke_mine.sql)
  mitSamtykke: Api['mitSamtykke'] = async () => (await this.c.k(this.c.sb.rpc('mit_samtykke', { k: await this.c.kraevKlient() }))) as Awaited<ReturnType<Api['mitSamtykke']>>;
  saetMitSamtykke: Api['saetMitSamtykke'] = async (ja) => {
    await this.c.k(this.c.sb.rpc('saet_mit_samtykke', { k: await this.c.kraevKlient(), p_ja: ja }));
    this.c.skift();
  };
  flytPrisFor: Api['flytPrisFor'] = (id, dato, start) => this.kat.kald('flytpris', { booking_id: id, dato, start });
  kundeFlyt: Api['kundeFlyt'] = async (id, dato, start, accepterGebyr = false) => {
    await this.kat.kald('flyt', { booking_id: id, dato, start, accepter: accepterGebyr });
    this.c.skift();
  };
}
